export default {
  index: [
    {
      path: '/gzuser',
      component: resolve => require(['./gzuserIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/gzuser/_router.js